import styled from 'styled-components';

export const Main = styled.div`
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 120px;

  @media only screen and (max-width: 950px) {
    flex-direction: column;
    align-items: center;
  }

  h2 {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    text-align: center;
    color: #081847;
  }
`;

export const Container = styled.div`
  width: 50%;
  padding: 0 0 0 180px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;

  img {
    width: 120px;
    margin-bottom: 16px;
    margin-top: 16px;
  }

  @media only screen and (max-width: 950px) {
    width: 100%;
    padding: 36px 0 0 0;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

export const Column = styled.div`
  display: flex;
  padding: 0 180px 0px 0;
  width: 50%;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-end;
  gap: 10px;

  a {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #ffffff;
    text-decoration: none;

    svg {
      margin-right: 8px;
      width: 14px;
    }
  }

  @media only screen and (max-width: 950px) {
    width: 100%;
    align-items: center;
    padding: 0;
  }
`;

export const Row = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  svg {
    width: 12px;
  }

  h2 {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 160%;
    color: #a5adba;
  }

  div.social-media {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 46px;
  }

  @media only screen and (max-width: 950px) {
    flex-direction: column;
    gap: 35px;
    padding-bottom: 35px;
  }
`;
